function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { promisify } from "./_utils/promisify";
import { styleIn } from "./_utils/styleOptions";
export function normalize(api, containerName) {
  return function (options) {
    var mergedOptions = _extends({
      duration: 300
    }, options); // the `scrollTop` has higher priority


    if (mergedOptions.scrollTop != null) {
      mergedOptions.selector = undefined;
    }

    if (!Number(mergedOptions.duration) || mergedOptions.duration < 0) {
      mergedOptions.duration = 0;
    }

    return promisify(api)(styleIn(mergedOptions, containerName));
  };
}